import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a23ffd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "form__parts" }
const _hoisted_3 = { class: "form__parts" }
const _hoisted_4 = { class: "form__checkbox" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form__checkbox-body" }, "ログイン情報を保持する", -1))
const _hoisted_6 = { class: "form__button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AHeading = _resolveComponent("AHeading")!
  const _component_ALabel = _resolveComponent("ALabel")!
  const _component_AInput = _resolveComponent("AInput")!
  const _component_ABody = _resolveComponent("ABody")!
  const _component_ACheckbox = _resolveComponent("ACheckbox")!
  const _component_AButton = _resolveComponent("AButton")!
  const _component_ALink = _resolveComponent("ALink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AHeading, {
      class: "form__header",
      level: 2
    }, {
      default: _withCtx(() => [
        _createTextVNode("ログイン")
      ], undefined, true),
      _: 1
    }),
    _createElementVNode("form", {
      class: "form__container",
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.signin()), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ALabel, { for: "email" }, {
          default: _withCtx(() => [
            _createTextVNode("メールアドレス")
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_AInput, {
          class: "form__input",
          type: "text",
          name: "email",
          value: _ctx.email,
          placeholder: "onecareer@onecareer.jp",
          "validate-rule": _ctx.emailValidateRule,
          "validate-mode": "blur",
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleInput($event, 'email'))),
          onValidateBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleValidateBlur($event, 'email')))
        }, null, 8, ["value", "validate-rule"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ALabel, { class: "form__label" }, {
          default: _withCtx(() => [
            _createTextVNode("パスワード")
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_ABody, {
          class: "form__body",
          size: "small"
        }, {
          default: _withCtx(() => [
            _createTextVNode("8文字以上の半角英数字記号")
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_AInput, {
          class: "form__input",
          type: "password",
          name: "password",
          value: _ctx.password,
          placeholder: "************",
          "validate-rule": _ctx.passwordValidateRule,
          "validate-mode": "blur",
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleInput($event, 'password'))),
          onValidateBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleValidateBlur($event, 'password')))
        }, null, 8, ["value", "validate-rule"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ACheckbox, {
          value: _ctx.checked,
          "data-value": true,
          onChange: _ctx.handleChange
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ], undefined, true),
          _: 1
        }, 8, ["value", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_AButton, {
          round: "",
          fill: "",
          bold: "",
          size: "medium",
          disabled: _ctx.buttonDisabled,
          processing: _ctx.processing,
          "prevent-default": _ctx.buttonDisabled,
          class: "form__button"
        }, {
          default: _withCtx(() => [
            _createTextVNode("ログイン")
          ], undefined, true),
          _: 1
        }, 8, ["disabled", "processing", "prevent-default"])
      ])
    ], 32),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "form__link"
      }, [
        _createVNode(_component_ALink, {
          to: link.to
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(link.text), 1)
          ], undefined, true),
          _: 2
        }, 1032, ["to"])
      ]))
    }), 128))
  ]))
}